import { render } from "./Editor.vue?vue&type=template&id=e18b6dc6&scoped=true"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=e18b6dc6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e18b6dc6"],['__file',"src/components/Editor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e18b6dc6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e18b6dc6', __exports__)) {
    api.reload('e18b6dc6', __exports__)
  }
  
  module.hot.accept("./Editor.vue?vue&type=template&id=e18b6dc6&scoped=true", () => {
    api.rerender('e18b6dc6', render)
  })

}


export default __exports__